<ng-container *transloco="let t">
  <span class="flex items-center gap-2">
    @if (showTodayLabel()) {
      <span class="font-medium text-text-brand-primary" data-testid="today-label">{{ t("Aujourd'hui") }}</span>
    } @else {
      <span data-testid="date-label">{{ date() | date: 'mediumDate' }}</span>
    }

    <pxc-form-instance-status-icon [exportData]="changesetExport()" [status]="status()" />
  </span>

  <pxc-action-buttons
    iconOnly
    size="xs"
    [actionButtons]="actionButtons()"
    [actions]="actions()"
    [hintDirection]="'bottom'" />
</ng-container>
